import { PublicKey } from "@solana/web3.js";

export const MARINADE_PROGRAM_ID = new PublicKey("MarBmsSgKXdrN1egZf5sqe1TMai9K1rChYNDJgjq7aD");

export const MARINADE_STATE_ADDRESS = new PublicKey("8szGkuLTAux9XMgZ2vtY39jVSowEcpBfFfD8hXSEqdGC");

export const MARINADE_SOL_PDA = new PublicKey("UefNb6z6yvArqe4cJHTXCqStRsKmWhGxnZzuHbikP5Q");

export const STEP_MARINADE_REFERRAL_ACCOUNT = new PublicKey("C2yfqhsa8X46uzAMwQgpCZ2ZTHpD9e3nRCtiADmeJ3as");
